import styles from './ShareDropdownSection.module.scss';
import React, { useState } from 'react';
import { CopyableOption, DropdownOption, toSocialMediaURL } from './ShareDropdown';
import { gtag } from '../../utils/analytics';

function GenericSection({ option }: ShareDropdownSectionProps) {
  return (
    <>
      {option.icon && <div className={styles.shareDropdownIcon}>{option.icon}</div>}
      <p className={styles.shareLabel}>{option.label}</p>
    </>
  );
}

/**
 * A share dropdown section is only rendered if we know the user can't natively
 * share stuff to social media.
 * @param option
 * @constructor
 */
export function ShareDropdownSection({ option }: ShareDropdownSectionProps) {
  switch (option.type) {
    case 'share':
      const href = toSocialMediaURL(option.platform, option.sharePayload);
      return (
        <a href={href.toString()} target="_blank" rel="noreferrer" className={styles.shareRow}>
          <GenericSection option={option} />
        </a>
      );
    case 'copy':
      return <CopyableSection option={option} />;
  }
}

function CopyableSection({ option }: { option: CopyableOption }) {
  const [display, setDisplay] = useState(option.label);

  async function copyToClipboard() {
    await navigator.clipboard.writeText(option.toCopy);
    setDisplay('Copied!');
    setTimeout(() => {
      setDisplay(option.label);
    }, 5000);

    gtag('event', 'copy text');
  }

  return (
    <div className={styles.shareRow} onClick={copyToClipboard}>
      <GenericSection
        option={{
          ...option,
          label: display,
        }}
      />
    </div>
  );
}

export type ShareDropdownSectionProps = {
  option: DropdownOption;
};
